import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-meta-display',
  templateUrl: './user-meta-display.component.html',
  styleUrls: ['./user-meta-display.component.scss']
})
export class UserMetaDisplayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
